import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7ef0caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full shadow-lg border select-none border-primary-100 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = { style: {"border-radius":"1rem"} }
const _hoisted_3 = { class: "flex items-center justify-center text-white dark:text-dark-text" }
const _hoisted_4 = { class: "text-base material-icons mr-1 font-bold" }
const _hoisted_5 = { class: "text-base font-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_7 = {
  class: "w-full",
  style: {"border-bottom-right-radius":"1rem","border-bottom-left-radius":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["panel-top flex no-select", _ctx.headerColor]),
        style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _hoisted_6,
        _renderSlot(_ctx.$slots, "header", {}, undefined, true)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "body", {}, undefined, true)
      ])
    ])
  ]))
}